// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"Search_searchContainer__9FPfD"};